module.exports = __webpack_public_path__ + "static/img/ld-font12.8a7ab9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ld-font12.png
// module id = w3yS
// module chunks = 1